import { LOCALE } from '@/constants/settings';

const DAY_IN_MS = 86_400_000;
const HOUR_IN_MS = 3_600_000;
const MIN_IN_MS = 60_000;

export const nowDate = new Date();
export const currentYear = nowDate.getFullYear();

const formatDigit = (n: number): string => n.toString().padStart(2, '0');

export const getDate = (d: Date): string =>
  `${formatDigit(d.getDate())}.${formatDigit(d.getMonth() + 1)}.${d.getFullYear()}`;

export const getShortDate = (d: Date): string =>
  new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'long' }).format(d);

export const formatDate = (timestamp: number): string => {
  const D = new Date(timestamp * 1000);

  const DATE_FORMAT = getDate(D);
  const TIME_FORMAT = `${formatDigit(D.getHours())}:${formatDigit(D.getMinutes())}`;

  return `${DATE_FORMAT} ${TIME_FORMAT}`;
};

export const secondsToMinutesAndSeconds = (seconds: number): string => {
  const MIN = Math.floor((seconds % 3600) / 60);
  const SEC = seconds % 60;

  return `${formatDigit(MIN)}:${formatDigit(SEC)}`;
};

const getTimeUntil = (date: Date): number => Math.abs(date.getTime() - nowDate.getTime());

export const getDateObject = (date: Date) => {
  const time = getTimeUntil(date);

  const days = Math.floor(time / DAY_IN_MS);

  const timeLeftMs = time - days * DAY_IN_MS;
  const hours = Math.floor(timeLeftMs / HOUR_IN_MS);
  const minutes = Math.floor((timeLeftMs % HOUR_IN_MS) / MIN_IN_MS);

  return {
    days,
    hours,
    minutes,
  };
};
